import { Link } from "react-router-dom";
import "./TalkCallToAction.scss";

const TalkCallToAction = () => {
  return (
    <section className="talk-cta" data-aos="fade-up">
      <div className="talk-cta__content">
        <p>
          Cada empresa tem seus próprios desafios. Vamos conversar sobre como
          podemos contribuir para o bem-estar da sua equipe?
        </p>
        <Link to="/talk" className="talk-cta__button">
          Converse com nossa equipe
        </Link>
      </div>
    </section>
  );
};

export default TalkCallToAction;
